import { render } from "./rectangle.vue?vue&type=template&id=e3842ad2&scoped=true"
import script from "./rectangle.vue?vue&type=script&lang=js"
export * from "./rectangle.vue?vue&type=script&lang=js"

import "./rectangle.vue?vue&type=style&index=0&id=e3842ad2&scoped=true&lang=scss"

import exportComponent from "/Users/bill/rongge/code/已售项目/20340305/front/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3842ad2"]])

export default __exports__